import React from "react";
import Section from "../../Layouts/Section";
import UsumLogo from "../../assets/images/logo-usum-software.png";
import VNGLogo from "../../assets/images/vng.png";
import DisionLogo from "../../assets/images/dision.png";
import Nexon from "../../assets/images/nexon.png";

import Item from "./Item";

interface iProps extends React.HTMLProps<HTMLDivElement> {}

const WorkExperience: React.FC<iProps> = () => {
  return (
    <Section id="workExpId" title="Work Experience " className="">
      <p className="mb-4">
        I have nearly 4 years of experience with TS and React library.Next
        Framework. Besides that, i proficient use of some UI library such as
        TailwindCss and Ant Design.
      </p>
      <div className="flex flex-col justify-start mt-4  gap-8">
        <Item
          key={"Nexon Dev Vina"}
          imgLogo={Nexon}
          companyName="Nexon Dev Vina"
          linkCompany="https://www.nexon.com/main/en"
          timeJob="Sep/2024 - Now"
          desJob={desJobNexon}
          nameJob="HTML5/Javascript Developer"
          colorCode="#c1d82f"
        />
        <Item
          key={"DISION/dynexo"}
          imgLogo={DisionLogo}
          companyName="DISION/dynexo"
          desJob={desJobDision}
          linkCompany="https://dision.tech/"
          timeJob="Jul/2024 - Sep/2024"
          nameJob="Frontend Engineer"
          colorCode="#25a9e1"
        />
        <Item
          key={"VNGGames"}
          imgLogo={VNGLogo}
          companyName="VNGGames"
          desJob={desJobVNG}
          linkCompany="https://vnggames.com/"
          timeJob="11/2022 - Aug/2024"
          nameJob="Software Engineer"
          colorCode="#ed5925"
        />
        <Item
          key={"Usum"}
          imgLogo={UsumLogo}
          companyName="Usum"
          linkCompany="https://www.usumsoftware.com/"
          colorCode="#f6bc08"
        />
      </div>
    </Section>
  );
};

export default WorkExperience;

const desJobVNG: string[] = [
  "Join 3 projects, it's about GE-Portal, GE-Talent and Aurora.",
  "Implement UI base on Figma.",
  "Login SSO - Microsoft.",
  "Handle state, data flow, check authentication of app.",
  "Discuss with teams to improve, edit flow, and feature.",
  "Use ECharts to show data.",
  "Work with SCRUM (Daily standup meetings, update and handle task on Jira)",
];

const desJobDision: string[] = [
  "Create Admin Application for low code",
  "Create Data Manager to adapt query all variants database such as Firebase, Pocketbase, Mysql,...",
  "Using ReactContext, Turborepo to manage mono repo",
];

const desJobNexon: string[] = [
  "Developed HTML5 playable ads mini-games using Phaser and TypeScript.",
  "Built lightweight game architectures optimized for ad platforms with bundle sizes under 5MB.",
  "Integrated advertising and analytics SDKs such as AppLovin and Airbridge.",
  "Optimized performance, asset loading, and rendering to ensure smooth gameplay across browsers and mobile devices.",
  "Collaborated closely with game designers to translate gameplay ideas into interactive playable ad experiences.",
  "Used modern web technologies including TypeScript, Vite, Three.js, Playroomkit, and Socket.io.",
  "Contributed to multiple projects including MapleStory, Maple Puzzle, Mabinogi, MapleStory Idle, and Boom-style multiplayer gameplay prototypes.",
];
